module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAm0lEQVR42u3awQnEMAwEwO2/g7SQJpUGjkTgEOzzCPZpm52PPk5VZecEAAAAAAAAAAAAAIDdAZL6i/QHAAAAABYHaFf9eRYAAAArAYyUBQAAwCNActYs6XcdegMAAAATAHxRFgAAAABsAQAAANwC1JGaOt3p3wcAAICVAN5GAQAAAIDlAUZQAAAAAMBHSQAAAAAAAAAAAAAAts0FLoNjQUnIRHYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Nagorno-Karabakh.png
// module id = Oc6q
// module chunks = 0 62 63